import { visionURL } from "../config/environment";
import Jsona from "jsona";
import JsonApiService from "../services/jsonapiService";
import visionCallService from "../services/visionCallService";
import { useState } from "react";

const dataFormatter = new Jsona();

const trainingLocationsApiService = async () =>
  new JsonApiService("training_locations", {
    baseUrl: `${visionURL}/admin_console/api/content`,
    credentials: "include"
  });

const coordinatesApiService = async () =>
  new JsonApiService("coordinates", {
    baseUrl: `${visionURL}/admin_console/api/content/training_locations`,
    credentials: "include"
  });

export const useTrainingLocations = () => {
  const [isSaving, setIsSaving] = useState(false);
  const getTrainingLocations = async ({ sortBy, page, filters }) => {
    const service = await trainingLocationsApiService();
    const response = await service
      .page(page)
      .sort(sortBy)
      .where(filters)
      .include(["status_type", "location"])
      .all()
      .then(response => response.json());
    return {
      data: dataFormatter.deserialize(response),
      totalCount: response.meta?.totalCount
    };
  };
  const createTrainingLocation = async newTrainingLocationData => {
    setIsSaving(true);
    const service = await trainingLocationsApiService();
    const response = await service
      .create(
        visionCallService.serializeRequestBody(
          newTrainingLocationData,
          "trainingLocation",
          ["location", "statusType"]
        )
      )
      .then(response => response.json());
    setIsSaving(false);
    if (response.errors) {
      throw response.errors;
    } else {
      return dataFormatter.deserialize(response);
    }
  };
  const updateTrainingLocation = async trainingLocationData => {
    setIsSaving(true);
    const service = await trainingLocationsApiService();
    const response = await service
      .update(
        trainingLocationData.id,
        visionCallService.serializeRequestBody(
          trainingLocationData,
          "trainingLocation",
          ["statusType"]
        )
      )
      .then(response => response.json());
    setIsSaving(false);
    if (response.errors) {
      throw response.errors;
    } else {
      return dataFormatter.deserialize(response);
    }
  };

  return {
    getTrainingLocations,
    createTrainingLocation,
    updateTrainingLocation,
    isSaving
  };
};

export const useTrainingLocationCoordinates = location => {
  const [isLoading, setIsLoading] = useState(false);
  const getCoordinates = async () => {
    setIsLoading(true);
    const service = await coordinatesApiService();
    const response = await service
      .customParams(location)
      .all()
      .then(response => response.json());
    setIsLoading(false);
    return response;
  };

  return {
    getCoordinates,
    isLoading
  };
};
